/* ==========================================================================
   nb-product-mini.js — Ledningsfri Mini Luftrenser-produktsiden.
   Port af logikken i design_handoff_mini/design/MiniLuftrenser.dc.html
   (BEHAVIOR.md): farvevalg, bundle-vælger (kvantitet 1/2/3), fælles
   add-to-cart for hoved-CTA + sticky bar, tilbehørs-køb og FAQ-accordion.

   Bundle-mekanik: kvantitetsvarianter — CTA'en lægger {antal} stk af den
   valgte farvevariant i kurven; checkout-prisen håndhæves af de automatiske
   rabatter (fx "2x LullaAir™ Mini": −129,50 kr/stk). De VISTE priser kommer
   fra Liquid via data-attributter — der regnes aldrig priser i hånden her.

   FILTER-UPSELL (tilføjet 25-08-2026): den aktive tier kan bære en tænd/sluk-
   knap, der lægger et tilbehørsprodukt i kurven sammen med hovedvaren.
   Alt er gated på [data-nb-upsell-toggle]: findes knappen ikke i DOM'en —
   som på LullaAir™-siden, der deler denne fil — opfører koden sig præcis som
   før. Priserne med filter kommer også fra Liquid, via -upsell-attributterne.

   Ingen dansk tekst i denne fil — alle strenge kommer fra data-attributter.
   (Undtagelse: <nb-mini-countdown> nederst, som er en ordret designport.)
   Alt er idempotent (Section Rendering API kan re-rendere DOM).
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- fælles helpers ---------- */

  function withSections(payload) {
    var cartApi = window.NBCart;
    if (cartApi && typeof cartApi.sectionsPayload === 'function') {
      var extra = cartApi.sectionsPayload();
      for (var key in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
      }
    }
    return payload;
  }

  function addToCart(addUrl, items) {
    return fetch((addUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(withSections({ items: items }))
    }).then(function (response) {
      return response
        .json()
        .catch(function () { return {}; })
        .then(function (data) {
          if (!response.ok) {
            var error = new Error('nb-mini');
            error.data = data;
            throw error;
          }
          return data;
        });
    });
  }

  function afterAdd(data) {
    var cartApi = window.NBCart;
    var instant = !!(data && data.sections && cartApi && typeof cartApi.apply === 'function' && cartApi.apply(data.sections));
    if (!instant && cartApi && typeof cartApi.refresh === 'function') cartApi.refresh();
    if (cartApi && typeof cartApi.get === 'function') {
      cartApi.get().then(function (cart) {
        window.dispatchEvent(new CustomEvent('nb-cart-updated', { detail: { cart: cart || null } }));
      });
    }
  }

  function errorText(error, fallback) {
    var data = error && error.data;
    if (data && typeof data.description === 'string' && data.description) return data.description;
    if (data && typeof data.message === 'string' && data.message) return data.message;
    return fallback || '';
  }

  /* ---------- købsblok + sticky bar (delt state) ---------- */

  function initBuy(root) {
    if (!root || root.__nbMiniBound) return;
    root.__nbMiniBound = true;

    var sticky = document.querySelector('[data-nb-ministicky]');

    function i18n(name, fallback) {
      var value = root.getAttribute('data-nb-i18n-' + name);
      return value === null || value === '' ? fallback : value;
    }

    function activeColor() {
      return root.querySelector('[data-nb-mini-color].is-active');
    }

    function activeTier() {
      return root.querySelector('[data-nb-minitier].is-active');
    }

    function upsellToggle(tier) {
      return tier ? tier.querySelector('[data-nb-upsell-toggle]') : null;
    }

    function state() {
      var color = activeColor();
      var tier = activeTier();
      var toggle = upsellToggle(tier);
      var on = !!(toggle && toggle.checked);

      var basePrice = tier ? (tier.getAttribute('data-nb-price-label') || '') : '';
      var baseWas = tier ? (tier.getAttribute('data-nb-was-label') || '') : '';
      var upPrice = tier ? (tier.getAttribute('data-nb-price-label-upsell') || '') : '';
      var upWas = tier ? (tier.getAttribute('data-nb-was-label-upsell') || '') : '';

      return {
        variantId: color ? color.getAttribute('data-nb-variant-id') : null,
        available: color ? color.getAttribute('data-nb-available') === 'true' : false,
        colorTitle: color ? (color.getAttribute('data-nb-color-title') || '') : '',
        image: color ? (color.getAttribute('data-nb-image') || '') : '',
        units: tier ? (parseInt(tier.getAttribute('data-nb-units'), 10) || 1) : 1,
        price: on && upPrice ? upPrice : basePrice,
        was: on && upWas ? upWas : baseWas,
        upsellId: on && toggle ? (toggle.getAttribute('data-nb-upsell-variant') || null) : null,
        upsellQty: toggle ? (parseInt(toggle.getAttribute('data-nb-upsell-qty'), 10) || 1) : 1,
        tierSuffix: tier ? (tier.getAttribute('data-nb-title-suffix') || '') : ''
      };
    }

    function sync() {
      var s = state();

      var stage = root.querySelector('[data-nb-mini-stage]');
      if (stage && s.image && stage.getAttribute('src') !== s.image) {
        stage.setAttribute('src', s.image);
        stage.setAttribute('alt', (root.getAttribute('data-nb-image-alt-prefix') || '') + s.colorTitle);
      }

      var idInput = root.querySelector('[data-nb-mini-id]');
      if (idInput && s.variantId) idInput.value = s.variantId;

      var badge = root.querySelector('[data-nb-mini-stock]');
      if (badge) {
        badge.classList.toggle('is-soldout', !s.available);
        var badgeText = badge.querySelector('[data-nb-mini-stock-text]');
        if (badgeText) badgeText.textContent = s.available ? i18n('stock-in', '') : i18n('stock-out', '');
      }

      var priceEl = root.querySelector('[data-nb-mini-price]');
      var wasEl = root.querySelector('[data-nb-mini-was]');
      if (priceEl && s.price) priceEl.textContent = s.price;
      if (wasEl) {
        wasEl.textContent = s.was;
        wasEl.hidden = s.was === '';
      }
      if (priceEl) priceEl.classList.toggle('is-sale', s.was !== '');

      var cta = root.querySelector('[data-nb-mini-add]');
      if (cta) {
        cta.disabled = !s.available;
        var label = cta.querySelector('[data-nb-mini-add-label]');
        if (label) {
          label.textContent = s.available
            ? i18n('cta', '').replace('[pris]', s.price)
            : i18n('soldout', '');
        }
      }

      if (sticky) {
        var stTitle = sticky.querySelector('[data-nb-ministicky-title]');
        var stPrice = sticky.querySelector('[data-nb-ministicky-price]');
        var stImg = sticky.querySelector('[data-nb-ministicky-img]');
        var stBtn = sticky.querySelector('[data-nb-ministicky-add]');
        var base = sticky.getAttribute('data-nb-title') || '';
        if (stTitle) stTitle.textContent = base + (s.colorTitle ? ' · ' + s.colorTitle : '') + (s.tierSuffix ? ' · ' + s.tierSuffix : '');
        if (stPrice) {
          stPrice.textContent = s.price;
          stPrice.classList.toggle('is-sale', s.was !== '');
        }
        if (stImg && s.image) stImg.setAttribute('src', s.image.replace('width=900', 'width=200'));
        if (stBtn) stBtn.disabled = !s.available;
      }

      if (s.variantId && window.history && typeof window.history.replaceState === 'function') {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', s.variantId);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          /* ingen handling — URL-sync er kosmetisk */
        }
      }
    }

    function add(button) {
      if (!button || button.disabled || button.getAttribute('data-nb-state') === 'adding') return;
      var s = state();
      if (!s.variantId || !s.available) return;

      var errorEl = root.querySelector('[data-nb-mini-error]');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }

      var label = button.querySelector('[data-nb-mini-add-label], [data-nb-ministicky-add-label]');
      var idle = label ? label.textContent : '';
      button.setAttribute('data-nb-state', 'adding');
      if (label) label.textContent = i18n('adding', idle);

      // Draweren aabnes med det samme; indholdet foelger i svaret (sections).
      window.dispatchEvent(new CustomEvent('nb-cart-open'));

      var items = [{ id: s.variantId, quantity: s.units }];
      if (s.upsellId) items.push({ id: s.upsellId, quantity: s.upsellQty });

      addToCart(root.getAttribute('data-nb-add-url'), items)
        .then(function (data) {
          afterAdd(data);
          if (label) label.textContent = i18n('added', idle);
          window.setTimeout(function () {
            button.removeAttribute('data-nb-state');
            sync();
          }, 1200);
        })
        .catch(function (error) {
          button.removeAttribute('data-nb-state');
          sync();
          if (errorEl) {
            errorEl.textContent = errorText(error, i18n('error', ''));
            errorEl.hidden = false;
          }
        });
    }

    root.addEventListener('click', function (event) {
      var color = event.target.closest('[data-nb-mini-color]');
      if (color && root.contains(color) && !color.disabled) {
        Array.prototype.forEach.call(root.querySelectorAll('[data-nb-mini-color]'), function (b) {
          b.classList.toggle('is-active', b === color);
          b.setAttribute('aria-checked', b === color ? 'true' : 'false');
        });
        sync();
        return;
      }
      // Klik paa upsell-knappen maa ikke boble videre som et tier-valg.
      if (event.target.closest('[data-nb-upsell]')) return;
      var tier = event.target.closest('[data-nb-minitier]');
      if (tier && root.contains(tier)) {
        Array.prototype.forEach.call(root.querySelectorAll('[data-nb-minitier]'), function (t) {
          t.classList.toggle('is-active', t === tier);
          t.setAttribute('aria-checked', t === tier ? 'true' : 'false');
        });
        sync();
        return;
      }
      var cta = event.target.closest('[data-nb-mini-add]');
      if (cta && root.contains(cta)) add(cta);
    });

    // Upsell-knappen spejles paa alle tiers, saa valget overlever et skift.
    root.addEventListener('change', function (event) {
      var toggle = event.target.closest('[data-nb-upsell-toggle]');
      if (!toggle || !root.contains(toggle)) return;
      Array.prototype.forEach.call(root.querySelectorAll('[data-nb-upsell-toggle]'), function (other) {
        other.checked = toggle.checked;
      });
      sync();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target.closest('[data-nb-upsell]')) return;
      var radio = event.target.closest('[data-nb-minitier], [data-nb-mini-color]');
      if (!radio) return;
      event.preventDefault();
      radio.click();
    });

    if (sticky && !sticky.__nbMiniBound) {
      sticky.__nbMiniBound = true;
      sticky.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-nb-ministicky-add]');
        if (btn) add(btn);
      });
    }

    sync();
  }

  /* ---------- tilbehør ("Køb også") ---------- */

  function initAddons(root) {
    if (!root || root.__nbMiniBound) return;
    root.__nbMiniBound = true;

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-nb-miniaddon-add]');
      if (!btn || btn.disabled || btn.getAttribute('data-nb-state') === 'adding') return;

      var variantId = btn.getAttribute('data-nb-variant-id');
      if (!variantId) return;

      var idle = btn.textContent;
      btn.setAttribute('data-nb-state', 'adding');
      btn.textContent = root.getAttribute('data-nb-i18n-adding') || idle;

      window.dispatchEvent(new CustomEvent('nb-cart-open'));

      addToCart(root.getAttribute('data-nb-add-url'), [{ id: variantId, quantity: 1 }])
        .then(function (data) {
          afterAdd(data);
          btn.textContent = root.getAttribute('data-nb-i18n-added') || idle;
          window.setTimeout(function () {
            btn.removeAttribute('data-nb-state');
            btn.textContent = idle;
          }, 1200);
        })
        .catch(function () {
          btn.removeAttribute('data-nb-state');
          btn.textContent = idle;
        });
    });
  }

  /* ---------- FAQ-accordion: én åben ad gangen ---------- */

  function initFaq(root) {
    if (!root || root.__nbMiniBound) return;
    root.__nbMiniBound = true;

    root.addEventListener('click', function (event) {
      var item = event.target.closest('[data-nb-minifaq-item]');
      if (!item || !root.contains(item)) return;
      var wasOpen = item.classList.contains('is-open');
      Array.prototype.forEach.call(root.querySelectorAll('[data-nb-minifaq-item]'), function (i) {
        i.classList.remove('is-open');
        var q = i.querySelector('[data-nb-minifaq-q]');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        var q = item.querySelector('[data-nb-minifaq-q]');
        if (q) q.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nb-minibuy]'), initBuy);
    Array.prototype.forEach.call(document.querySelectorAll('[data-nb-miniaddons]'), initAddons);
    Array.prototype.forEach.call(document.querySelectorAll('[data-nb-minifaq]'), initFaq);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();


/* ------------------------------------------------------------------------
   <nb-mini-countdown> — port af designets nb-countdown fra
   design_handoff_mini/design/nb-widgets.js (temaets globale <nb-countdown>
   render anderledes og maatte ikke roeres). Hverdag foer cutoff: blaa
   live-nedtaelling "Bestil inden HH:MM:SS — saa sender vi i dag"; ellers
   "Bestil nu — vi sender paa mandag/naeste hverdag". Dansk datoformat.

   YDELSE (25-08-2026): tidligere blev hele elementets innerHTML skrevet om
   hvert sekund. Det tvang browseren til at bygge DOM, layoute og tegne
   blokken forfra én gang i sekundet midt i koebsblokken — et regelmaessigt
   hak paa hele siden. Nu bygges strukturen ÉN gang; hvert sekund roeres kun
   selve ciffer-teksten, og kun naar den faktisk er aendret. Overskriften
   bygges om alene naar tilstanden skifter (foer/efter cutoff, weekend), og
   leveringsdatoen naar dagen skifter — altsaa hoejst et par gange i doegnet.
   Tallene staar i tabular-nums, saa bredden ikke aendrer sig og teksten
   dermed ikke reflower.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';
  if (customElements.get('nb-mini-countdown')) return;

  class NbMiniCountdown extends HTMLElement {
    connectedCallback() {
      this.cutoff = parseInt(this.getAttribute('cutoff') || '14', 10);
      this.theme = this.getAttribute('theme') || 'light';
      this._headKey = null;
      this._clockText = null;
      this._deliverText = null;
      this._clock = null;
      this.build();
      this.tick();
      this._t = window.setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback() {
      if (this._t) { window.clearInterval(this._t); this._t = null; }
    }
    pad(n) { return String(n).padStart(2, '0'); }
    addBusinessDays(date, n) {
      const d = new Date(date);
      while (n > 0) { d.setDate(d.getDate() + 1); const wd = d.getDay(); if (wd !== 0 && wd !== 6) n--; }
      return d;
    }
    fmtDate(d) {
      const days = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
      const months = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
      return days[d.getDay()] + ' d. ' + d.getDate() + '. ' + months[d.getMonth()];
    }

    /* Bygges én gang. Kun [data-nb-cd-*] roeres senere. */
    build() {
      const ink = this.theme === 'dark' ? '#F4ECDF' : '#3A2E22';
      const sub = this.theme === 'dark' ? '#C9BBA9' : '#8A7A6D';
      this.innerHTML =
        '<span style="display:flex;align-items:flex-start;gap:11px;font-family:Nunito,sans-serif;">' +
          '<span data-nb-cd-icon style="font-size:20px;flex:none;line-height:1.25;"></span>' +
          '<span style="line-height:1.35;">' +
            '<span data-nb-cd-head style="display:block;font-size:13.5px;font-weight:700;color:' + ink + ';"></span>' +
            '<span style="display:block;font-size:12.5px;font-weight:700;color:' + sub + ';margin-top:2px;">📅 Modtag <b data-nb-cd-deliver style="color:' + ink + ';"></b></span>' +
          '</span>' +
        '</span>';
      this._icon = this.querySelector('[data-nb-cd-icon]');
      this._head = this.querySelector('[data-nb-cd-head]');
      this._deliver = this.querySelector('[data-nb-cd-deliver]');
    }

    /* Overskriften bygges kun om, naar tilstanden faktisk skifter. */
    setHead(key, weekend) {
      if (this._headKey === key) return;
      this._headKey = key;
      if (key === 'live') {
        this._head.innerHTML =
          'Bestil inden <b data-nb-cd-clock style="font-variant-numeric:tabular-nums;color:#1A5FE0;"></b> — så sender vi <b>i dag</b>';
        this._clock = this._head.querySelector('[data-nb-cd-clock]');
        this._clockText = null;
        this._icon.textContent = '🚚';
      } else {
        this._head.innerHTML = 'Bestil nu — vi sender <b>' + (weekend ? 'på mandag' : 'næste hverdag') + '</b>';
        this._clock = null;
        this._clockText = null;
        this._icon.textContent = '📦';
      }
    }

    tick() {
      const now = new Date();
      const day = now.getDay(); // 0=søn,6=lør
      const cut = new Date(now); cut.setHours(this.cutoff, 0, 0, 0);
      const weekend = day === 0 || day === 6;
      const beforeCut = !weekend && now < cut;

      this.setHead(beforeCut ? 'live' : (weekend ? 'next-weekend' : 'next'), weekend);

      if (beforeCut && this._clock) {
        const d = cut - now;
        const h = Math.floor(d / 3600000);
        const m = Math.floor((d % 3600000) / 60000);
        const s = Math.floor((d % 60000) / 1000);
        const text = this.pad(h) + ':' + this.pad(m) + ':' + this.pad(s);
        if (text !== this._clockText) {
          this._clockText = text;
          this._clock.textContent = text;
        }
      }

      // ship day: today if before cutoff on a weekday, else next business day
      let ship = new Date(now); ship.setHours(0, 0, 0, 0);
      if (!beforeCut) ship = this.addBusinessDays(ship, 1);
      // latest delivery = ship + 2 business days
      const deliverText = 'senest ' + this.fmtDate(this.addBusinessDays(ship, 2));
      if (deliverText !== this._deliverText) {
        this._deliverText = deliverText;
        this._deliver.textContent = deliverText;
      }
    }
  }
  customElements.define('nb-mini-countdown', NbMiniCountdown);
})();
